import * as React from 'react';
import { Component } from 'react';
import './DaySpan.css'
import { WEEKDAYS_SHORT } from '../constants/DateConsts';


interface IProps {
    DaySpan: number,
    OnSpanChange: (dateFrom: Date, dateTo: Date) => void,
    StartDate: Date
}

export class DaySpanComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);

        this.OnPrevClick = this.OnPrevClick.bind(this);
        this.OnNextClick = this.OnNextClick.bind(this);
    }

    public render() {
        return (
            <div className="day-span-component">
                <div className="prev">
                    <span onClick={this.OnPrevClick} />
                </div>
                {this.RenderDayItems()}
                <div className="next">
                    <span onClick={this.OnNextClick} />
                </div>
            </div>
        );
    }

    private RenderDayItems() {
        let dayTable: Date[] = [];
        for (let i = 0; i < this.props.DaySpan; i++) {
            dayTable.push(new Date(
                this.props.StartDate.getFullYear(),
                this.props.StartDate.getMonth(),
                this.props.StartDate.getDate() + i));
        }
        return (dayTable.map((date) => (
            <div className="day" key={date.getTime()}>
                <span className="day-of-week">
                    {WEEKDAYS_SHORT[(date.getDay())]}
                </span>
                <span className="date-value">
                    {("0" + date.getDate().toString()).slice(-2)}.{("0" + (date.getMonth() + 1).toString()).slice(-2)}
                </span>
            </div>
        )));
    }

    private OnPrevClick(e) {
        let newStartDate = new Date(
            this.props.StartDate.getFullYear(),
            this.props.StartDate.getMonth(),
            this.props.StartDate.getDate() - 1)
        if (newStartDate.getTime() < (new Date()).getTime()) {
            return;
        }
        this.setState({
            CurrentStartDate: newStartDate
        });
        this.props.OnSpanChange(newStartDate, new Date(
            newStartDate.getFullYear(),
            newStartDate.getMonth(),
            newStartDate.getDate() + this.props.DaySpan - 1));
    }

    private OnNextClick(e) {
        let newStartDate = new Date(
            this.props.StartDate.getFullYear(),
            this.props.StartDate.getMonth(),
            this.props.StartDate.getDate() + 1)
        this.setState({
            CurrentStartDate: newStartDate
        });
        this.props.OnSpanChange(newStartDate, new Date(
            newStartDate.getFullYear(),
            newStartDate.getMonth(),
            newStartDate.getDate() + this.props.DaySpan - 1));
    }
}


// WEBPACK FOOTER //
// ./src/controls/DaySpan.tsx